// extracted by mini-css-extract-plugin
export default {"container":"list-loader_container__mJHxX","body":"list-loader_body__rc2NG"};